module.exports = __webpack_public_path__ + "static/media/CNBC_Logo_White.9ca9f8fb.svg";